import React, { useState } from 'react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <footer className="bg-green-deep text-white/80 py-12 px-4 border-t border-white/10" data-id="element-73">
      <div className="max-w-4xl mx-auto text-center" data-id="element-74">
        <p className="mb-6 text-sm" data-id="element-75">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-medium" data-id="element-76">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-4" data-id="element-77">
            Políticas de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-4" data-id="element-78">
            Términos y Condiciones
          </button>
        </div>

        <p className="mt-8 text-xs text-white/50" data-id="element-79">
          &copy; {new Date().getFullYear()} Inmunidad Total. Todos los derechos
          reservados.
        </p>
      </div>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-text-main/80 backdrop-blur-sm" data-id="element-80">
          <div className="bg-white text-text-main rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl animate-fade-in" onClick={e => e.stopPropagation()} data-id="element-81">
            <div className="flex justify-between items-center p-6 border-b border-gray-100" data-id="element-82">
              <h2 className="font-heading font-bold text-2xl text-green-deep" data-id="element-83">
                {activeModal === 'privacy' ? 'Políticas de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={closeModal} className="text-gray-400 hover:text-text-main transition-colors text-2xl leading-none" data-id="element-84">
                &times;
              </button>
            </div>

            <div className="p-6 overflow-y-auto font-body text-sm md:text-base text-text-main/80 space-y-4" data-id="element-85">
              {activeModal === 'privacy' ? <>
                  <p data-id="element-86">
                    <strong data-id="element-87">1. Información que recopilamos</strong>
                  </p>
                  <p data-id="element-88">
                    Recopilamos información que usted nos proporciona
                    directamente cuando utiliza nuestro sitio web, como cuando
                    se registra, realiza una compra o se suscribe a nuestro
                    boletín. Esta información puede incluir su nombre, dirección
                    de correo electrónico y detalles de pago procesados a través
                    de pasarelas seguras de terceros.
                  </p>

                  <p data-id="element-89">
                    <strong data-id="element-90">2. Uso de la información</strong>
                  </p>
                  <p data-id="element-91">
                    Utilizamos la información recopilada para procesar
                    transacciones, enviar correos electrónicos periódicos
                    relacionados con su pedido u otros productos y servicios, y
                    para mejorar nuestro sitio web y la experiencia del usuario.
                    No vendemos, intercambiamos ni transferimos a terceros su
                    información personal identificable.
                  </p>

                  <p data-id="element-92">
                    <strong data-id="element-93">3. Cookies y tecnologías de seguimiento</strong>
                  </p>
                  <p data-id="element-94">
                    Utilizamos cookies y tecnologías similares para rastrear la
                    actividad en nuestro sitio web y retener cierta información.
                    Esto nos ayuda a analizar datos sobre el tráfico de la
                    página web y mejorar nuestro sitio para adaptarlo a las
                    necesidades del cliente. Utilizamos esta información para
                    fines de análisis estadístico y marketing, incluyendo
                    publicidad en plataformas como Facebook y Google.
                  </p>

                  <p data-id="element-95">
                    <strong data-id="element-96">4. Publicidad de terceros</strong>
                  </p>
                  <p data-id="element-97">
                    Podemos utilizar empresas de publicidad de terceros para
                    publicar anuncios cuando visite nuestro sitio web. Estas
                    empresas pueden utilizar información (que no incluye su
                    nombre, dirección, dirección de correo electrónico o número
                    de teléfono) sobre sus visitas a este y otros sitios web
                    para proporcionar anuncios sobre bienes y servicios de su
                    interés.
                  </p>

                  <p data-id="element-98">
                    <strong data-id="element-99">5. Consentimiento</strong>
                  </p>
                  <p data-id="element-100">
                    Al utilizar nuestro sitio web, usted acepta nuestra política
                    de privacidad.
                  </p>
                </> : <>
                  <p data-id="element-101">
                    <strong data-id="element-102">1. Aceptación de los términos</strong>
                  </p>
                  <p data-id="element-103">
                    Al acceder y utilizar este sitio web, usted acepta estar
                    sujeto a estos Términos y Condiciones de uso, todas las
                    leyes y regulaciones aplicables, y acepta que es responsable
                    del cumplimiento de las leyes locales aplicables. Si no está
                    de acuerdo con alguno de estos términos, se le prohíbe
                    utilizar o acceder a este sitio.
                  </p>

                  <p data-id="element-104">
                    <strong data-id="element-105">2. Licencia de uso</strong>
                  </p>
                  <p data-id="element-106">
                    Se concede permiso para descargar temporalmente una copia de
                    los materiales (información o software) en este sitio web
                    solo para visualización transitoria personal y no comercial.
                    Esta es la concesión de una licencia, no una transferencia
                    de título, y bajo esta licencia usted no puede: modificar o
                    copiar los materiales; utilizar los materiales para
                    cualquier propósito comercial; intentar descompilar o
                    aplicar ingeniería inversa a cualquier software contenido en
                    el sitio web; eliminar cualquier derecho de autor u otras
                    anotaciones de propiedad de los materiales.
                  </p>

                  <p data-id="element-107">
                    <strong data-id="element-108">3. Descargo de responsabilidad</strong>
                  </p>
                  <p data-id="element-109">
                    Los materiales en este sitio web se proporcionan "tal cual".
                    No ofrecemos garantías, expresas o implícitas, y por la
                    presente renunciamos y negamos todas las demás garantías,
                    incluyendo, sin limitación, garantías implícitas o
                    condiciones de comerciabilidad, idoneidad para un propósito
                    particular, o no infracción de propiedad intelectual u otra
                    violación de derechos. Además, no garantizamos ni hacemos
                    ninguna representación con respecto a la exactitud, los
                    resultados probables o la confiabilidad del uso de los
                    materiales en nuestro sitio web.
                  </p>

                  <p data-id="element-110">
                    <strong data-id="element-111">4. Limitaciones</strong>
                  </p>
                  <p data-id="element-112">
                    En ningún caso nosotros o nuestros proveedores seremos
                    responsables de ningún daño (incluyendo, sin limitación,
                    daños por pérdida de datos o ganancias, o debido a
                    interrupción del negocio) que surja del uso o la incapacidad
                    de usar los materiales en este sitio web.
                  </p>

                  <p data-id="element-113">
                    <strong data-id="element-114">5. Modificaciones</strong>
                  </p>
                  <p data-id="element-115">
                    Podemos revisar estos términos de uso para nuestro sitio web
                    en cualquier momento sin previo aviso. Al utilizar este
                    sitio web, usted acepta estar sujeto a la versión actual de
                    estos Términos y Condiciones de uso.
                  </p>
                </>}
            </div>

            <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-2xl text-right" data-id="element-116">
              <button onClick={closeModal} className="bg-green-deep text-white px-6 py-2 rounded-lg font-bold hover:bg-green-deep/90 transition-colors" data-id="element-117">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </footer>;
}